import React from 'react';
import { useSelector } from 'react-redux';
import { Text, Modal, Button } from '@rsos/components/capstone/base';
import {
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';

const ReuploadModal = ({ isOpened, onClose, onConfirm }) => {
  const issues = useSelector(state => state.issues);
  const { creating } = issues;
  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={405}
      id="modal-reupload-jurisdiction-details"
    >
      <ModalHeader onClose={onClose}>
        <Text size="header" color="secondaryText" fontWeight="semibold">
          Upload New Jurisdictional Boundary
        </Text>
      </ModalHeader>
      <ModalBody>
        <Text size="small" color="secondaryText">
          Uploading a new jurisdictional boundary will overwrite the existing
          jurisdictional boundary. The new jurisdictional boundary will be
          inactive until it has been approved by RapidSOS. Are you sure you want
          to upload a new file?
        </Text>
      </ModalBody>
      <ModalFooter flow={12}>
        <Button
          btnType="primary"
          onClick={onConfirm}
          grow
          noMargin
          isLoadingProp={creating}
        >
          Upload File
        </Button>
        <Button btnType="tertiary" onClick={onClose} grow noMargin>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ReuploadModal;
